import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const TrackingHome = () => {
  const [trackingId, setTrackingId] = useState("");
  const navigate = useNavigate();

  const handleTrack = (e) => {
    e.preventDefault();

    if (!trackingId.trim()) {
      alert("Please enter a tracking number");
      return;
    }

    navigate(`/tracking/details?id=${trackingId}`);
  };

  const handlePickup = () => {
    const phone = "919959971831";
    const message = encodeURIComponent("Hi, I want to request a pickup.");
    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  };

  return (
    <main className="min-h-screen bg-[#1e4ed8] flex justify-center items-center px-1.5">
      {/* Mobile Container */}
      <div className="w-full max-w-[430px] bg-[#e9e9e9] rounded-[16px] p-2 space-y-6 shadow-lg">

        {/* Title */}
        <h1 className="text-[26px] font-bold text-black text-center">
          Track Your Parcel
        </h1>

        {/* Illustration */}
        <div className="w-full h-[180px] rounded-[16px] overflow-hidden bg-gray-200">
          <img
            src="/mobile-illustration.png"
            alt="Tracking"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Tracking Form */}
        <form onSubmit={handleTrack} className="space-y-2">

          <input
            type="text"
            placeholder="Enter Tracking Number"
            value={trackingId}
            onChange={(e) => setTrackingId(e.target.value)}
            className="w-full px-4 py-3 rounded-full border border-gray-300 
                       focus:outline-none focus:ring-2 focus:ring-blue-500 text-center"
          />

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded-full 
                       font-semibold text-lg hover:bg-blue-700 active:scale-95 transition"
          >
            Track Now
          </button>
        </form>

        {/* Pickup Button */}
        <button
          onClick={handlePickup}
          className="w-full bg-green-500 text-white py-3 rounded-full 
                     font-semibold text-lg hover:bg-green-600 active:scale-95 transition"
        >
          Request Pickup via Whatsapp
        </button>

        {/* Contact */}
        <p className="text-center text-sm text-gray-600">
          Contact: <span className="font-bold">9959971831</span>
        </p>

      </div>
    </main>
  );
};

export default TrackingHome;